import { render } from "./TeamHomeAway.vue?vue&type=template&id=dc0cc892&scoped=true"
import script from "./TeamHomeAway.vue?vue&type=script&lang=js"
export * from "./TeamHomeAway.vue?vue&type=script&lang=js"

import "@/assets/css/print.css?vue&type=style&index=0&id=dc0cc892&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0cc892"]])

export default __exports__